import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

export default (routes = []) => {
  const router = new VueRouter({
    routes
  })

  // 路由守卫
  router.beforeEach((to, from, next) => {
    if (to.path !== '/login' && !sessionStorage.getItem('token')) {
      window.location.replace('index.html')
    } else {
      next()
    }
  })
  return router
}
